import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-md-8 mx-auto" }
const _hoisted_3 = { class: "table table-bordered align-middle text-start" }
const _hoisted_4 = { class: "align-top" }
const _hoisted_5 = { class: "px-4 py-3" }
const _hoisted_6 = { class: "px-4 py-3" }
const _hoisted_7 = { class: "px-4 py-3" }

import HeaderBanner from './HeaderBanner.vue';
import BulletPointList from '../common/BulletPointList.vue';
import { BulletListItem } from '@/guiide/ts/components/bulletListIconStyle';


export default /*@__PURE__*/_defineComponent({
  __name: 'GuaranteedIncomeHL',
  setup(__props) {

const annuityIncomeBullets = new Array<BulletListItem>(
    { subtitle: "Level income:", text: "Same payment each year. Simple, but inflation may reduce its buying power over time." },
    { subtitle: "Increasing income:", text: "Payments will increase annually, usually by 3% or 5%. Starts lower but helps offset inflation." },
    { subtitle: "Inflation-linked income:", text: "Payments track the Retail Price Index (RPI), helping maintain your spending power as prices rise." },
)

const annuityPaymentPeriodBullets = new Array<BulletListItem>(
    { subtitle: "Monthly", text: "" },
    { subtitle: "Quarterly", text: "" },
    { subtitle: "Half-yearly", text: "" },
    { subtitle: "Annually", text: "" },
);

const annuityPaymentTypeBullets = new Array<BulletListItem>(
    { subtitle: "In advance:", text: "(starting immediately)." },
    { subtitle: "In arrears:", text: "(paid at the end of each period)." }
);

const annuityDeathBullets = new Array<BulletListItem>(
    { subtitle: "Single Life:", text: "Income stops when you die." },
    { subtitle: "Joint Life:", text: "A percentage (e.g. 50%, 66%, 100%) continues to your partner." },
    { subtitle: "Guarantee Period:", text: "Income is paid for a set time, even if you pass away." },
    { subtitle: "Value Protection:", text: "Returns unused funds to your beneficiaries." }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderBanner, { title: "Annuity" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mb-5" }, [
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, "What is an annuity?")
          ]),
          _createElementVNode("p", null, " An annuity is a retirement product offered by insurance companies that lets you exchange some or all of your pension for a regular income guaranteed for life. "),
          _createElementVNode("p", null, " You can typically choose to receive up to 25% as a tax-free cash lump sum, using the remainder to purchase the annuity. The income from the annuity is taxed as earned income. ")
        ], -1)),
        _createElementVNode("div", null, [
          _cache[4] || (_cache[4] = _createElementVNode("p", null, [
            _createElementVNode("strong", null, "Understanding Annuity Features: What's included and why they matter")
          ], -1)),
          _createElementVNode("table", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("thead", { class: "text-center" }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "pt-4 pb-2",
                  scope: "col"
                }, [
                  _createElementVNode("img", {
                    src: "/Content/images/HL/annuity_income.png",
                    alt: "Capital protection",
                    width: "48",
                    height: "48",
                    class: "img-fluid"
                  }),
                  _createElementVNode("p", { class: "mt-2" }, "Annuity income options")
                ]),
                _createElementVNode("th", {
                  class: "pt-4 pb-2",
                  scope: "col"
                }, [
                  _createElementVNode("img", {
                    src: "/Content/images/HL/annuity_payment.png",
                    alt: "Capital protection",
                    width: "48",
                    height: "48",
                    class: "img-fluid"
                  }),
                  _createElementVNode("p", { class: "mt-2" }, "Annuity payment options")
                ]),
                _createElementVNode("th", {
                  class: "pt-4 pb-2",
                  scope: "col"
                }, [
                  _createElementVNode("img", {
                    src: "/Content/images/HL/annuity_deathbenefits.png",
                    alt: "Capital protection",
                    width: "48",
                    height: "48",
                    class: "img-fluid"
                  }),
                  _createElementVNode("p", { class: "mt-2" }, "Annuity death benefits")
                ])
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("tr", null, [
                _createElementVNode("td", { class: "px-4 pt-3 pb-2" }, "An annuity payment can stay the same or increase each year. Increases will mean you start with less, but your income will be better protected from inflation. When choosing which option is right for you, you should keep in mind how your spending might change in retirement and how inflation increases prices over time."),
                _createElementVNode("td", { class: "px-4 pt-3 pb-2" }, [
                  _createElementVNode("p", null, "Choose to receive income monthly, quarterly, half-yearly or annually, either in advance (starting immediately) or in arrears (paid at the end of each period)."),
                  _createElementVNode("p", null, "Choose how often you receive your income payments:")
                ]),
                _createElementVNode("td", { class: "px-4 pt-3 pb-2" }, "You could choose an annuity beneficiary payment option which will pay your annuity income to your loved ones when you die, potentially tax free.")
              ], -1)),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_5, [
                  _createVNode(BulletPointList, { items: _unref(annuityIncomeBullets) }, null, 8, ["items"]),
                  _cache[0] || (_cache[0] = _createElementVNode("p", { class: "pt-2" }, "When choosing, consider how spending might change and how inflation could affect your future costs.", -1))
                ]),
                _createElementVNode("td", _hoisted_6, [
                  _createVNode(BulletPointList, { items: _unref(annuityPaymentPeriodBullets) }, null, 8, ["items"]),
                  _cache[1] || (_cache[1] = _createElementVNode("hr", null, null, -1)),
                  _createVNode(BulletPointList, { items: _unref(annuityPaymentTypeBullets) }, null, 8, ["items"])
                ]),
                _createElementVNode("td", _hoisted_7, [
                  _createVNode(BulletPointList, { items: _unref(annuityDeathBullets) }, null, 8, ["items"])
                ])
              ])
            ])
          ])
        ]),
        _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"mt-5 mb-4\" data-v-25c75bc2><h4 data-v-25c75bc2>Enhanced annuities: boost your annuity income in minutes</h4></div><div class=\"mb-4\" data-v-25c75bc2><p data-v-25c75bc2><strong data-v-25c75bc2>What is an enhanced annuity?</strong></p><p data-v-25c75bc2> Enhanced annuities pay you a higher rate of income depending on your lifestyle choices and medical conditions. </p><p data-v-25c75bc2> Even confirming some basic details, could mean you get a higher income. For example, your height, weight, smoking history or relationship status. </p><p data-v-25c75bc2> It&#39;s important to confirm as much information as you can, including your partner&#39;s details to make sure you get the highest income possible. </p></div><div class=\"mb-4\" data-v-25c75bc2><p data-v-25c75bc2><strong data-v-25c75bc2>What medical conditions qualify for an enhanced annuity?</strong></p><p data-v-25c75bc2> Providers take into account minor to serious medical conditions when you get an enhanced quote. Common conditions include: </p><ul data-v-25c75bc2><li data-v-25c75bc2> High blood pressure </li><li data-v-25c75bc2> High cholesterol </li><li data-v-25c75bc2> Diabetes </li><li data-v-25c75bc2> Stroke </li></ul><p data-v-25c75bc2> There are lots of other conditions which could mean you get more for your money. </p><p data-v-25c75bc2> You can buy an annuity any time from age 55 (rising to 57 from 2028). Our annuity comparison tool helps you shop around the whole UK open market in minutes. </p></div><div class=\"mb-4\" data-v-25c75bc2><p data-v-25c75bc2><strong data-v-25c75bc2>Do you need a medical examination for an enhanced annuity?</strong></p><p data-v-25c75bc2> In most cases, you don&#39;t need to go for a medical examination. But some annuity providers might ask your GP for your medical reports depending on your circumstances and health conditions. If you&#39;re a smoker, annuity providers might ask you to take a test to confirm this. </p><p data-v-25c75bc2> It&#39;s important you give accurate information when you request an enhanced annuity. If you don&#39;&#39;t, the annuity rate you&#39;re offered might change or be withdrawn. </p></div><div class=\"mb-4\" data-v-25c75bc2><p data-v-25c75bc2><strong data-v-25c75bc2>Next steps</strong></p><p data-v-25c75bc2> Call one of our Retirement Specialists on 0117 314 1798 to discuss your options and have your questions answered. If you want to proceed with purchasing an annuity they&#39;ll support you with this. You can also email the team at <a href=\"mailto:retire@hl.co.uk\" data-v-25c75bc2>retire@hl.co.uk</a>. </p></div>", 5))
      ])
    ])
  ], 64))
}
}

})